<div class="tw-relative" [ngClass]="{'tw-hidden': hideContentBySlug && isBlocked }" >
  <div  (click)="handleClick($event)" class="tw-absolute tw-top-0 tw-w-full tw-h-[100%] tw-z-10 tw-cursor-not-allowed" *ngIf="isBlocked" mhTooltip [mhTooltip]="message | translate: translateParams" [position]="tooltipPosition" width="fit-content"></div>
  <ng-content></ng-content>
</div>
